<template>
    <div :key="updateKey">
        <!-- <FullPageLoader :isLoading="loading"/> -->

        <div v-if="_.isNull(floorPlan)">
            <b-notification type="is-warning" aria-close-label="Close notification">
                <span v-if="user.role == 'pit'">Er is nog geen plattegrond gemaakt voor deze organisatie!</span>
                <span v-else>Er is nog geen plattegrond beschikbaar.</span>
            </b-notification>
        </div>
        <div v-else-if="!floorPlan" class="row">
            <div class="column">
                <form class="form" style="overflow: auto;">
                    <div class="column text-center">
                        <br>
                        <h4>Kies eerst een organisatie!</h4>
                    </div>
                </form>
            </div>
        </div>
        <div v-else>
            <div class="row" v-if="floorPlan && Object.keys(floorPlan).length">
                <div class="column is-half">
                    <b-field label="Zoek een box">
                        <b-autocomplete
                            :data="boxesFound"
                            field="number"
                            placeholder="Zoek op nummer"
                            :loading="isFetching"
                            @input="findBox"
                            @select="option => selectedBox = option"
                            expanded
                            clearable
                        >
                            <template v-slot="props">
                                <span v-if="user && user.role == 'pit' && dataBelongsTo == 'all'">{{ organisations[props.option.organisation].name }}&nbsp;-&nbsp;</span>
                                <strong>Nummer:</strong> {{ props.option.number }}&nbsp;-&nbsp;<strong>Grootte:</strong> {{ props.option.size || '-' }}m<sup>3</sup>&nbsp;-&nbsp;<strong>Prijs:</strong> &euro;&nbsp;{{ props.option.price}}
                            </template>
                        </b-autocomplete>
                    </b-field>
                </div>
                <div class="column is-half">
                    <b-field label="Verdieping">
                        <b-select v-model="activeFloor" :disabled="loading" expanded>
                            <option
                                v-for="(floor, index) in floorPlan"
                                :value="parseInt(index)"
                                :key="'floor_'+index"
                            >{{ floor.name }}</option>
                        </b-select>
                    </b-field>
                </div>
            </div>

            <!-- <div class="row">
                <div class="column">
                    <b-field label="Statussen"></b-field>
                </div>
            </div>
            <div class="legenda" :key="'legenda-' + selectedFilters.length + '-' + selectedFilters.join(',')">
                <div v-for="filter in possibleFilters" :key="filter.name" class="filter">
                    <label class="b-checkbox checkbox" :class="filter.name">
                        <input
                            type="checkbox"
                            :checked="selectedFilters.includes(filter.name)"
                            @click="handleFilterClick(filter.name)"
                        >
                        <span class="check"></span>
                        <span class="control-label">{{ filter.label }}</span>
                    </label>
                </div>
            </div> -->
            <div class="floormap-wrap">
                <div class="loading" v-show="loading"><div class="lds-ripple"><div></div></div></div>

                <pinch-zoom wheel="false">
                    <div id="floorplan" style="width: 100%;"></div>
                </pinch-zoom>

                <!-- <div class="legenda">
                    <div class="infobox free"></div>
                    <div class="infobox reserved"></div>&nbsp;Gereserveerd
                    <div class="infobox ending"></div>&nbsp;Aflopend
                    <div class="infobox taken"></div>&nbsp;Verhuurd
                    <div class="infobox takenreserved"></div>&nbsp;Verhuurd + Gereserveerd
                    <div class="infobox inactive"></div>&nbsp;Inactief
                </div> -->

                <div class="boxinfo" :class="{ 'left': leftSided }" v-show="showInfo" ref="boxinfo">
                    <div v-if="!_.isNull(hoveringObj)">
                        <BoxesOverviewStatus
                            :status="hoveringObj.status"
                        />
                        <p class="content">
                            <strong>Nummer:</strong>&nbsp;{{ hoveringObj.number || '-' }}<br>
                            <strong>Grootte:</strong>&nbsp;{{ hoveringObj.size || '-' }}m³<br>
                            <span v-show="hoveringObj.length && hoveringObj.width">
                                <strong>LxBxH:</strong>
                                {{ `${hoveringObj.length ? hoveringObj.length : '-'} x ${hoveringObj.width ? hoveringObj.width : '-'} x ${hoveringObj.height ? hoveringObj.height : '-'}` }}
                                <br>
                            </span>
                            <strong>Prijs:</strong>&nbsp;&euro;&nbsp;{{ hideSensitiveData ? '********' : hoveringObj.price }}<br>
                            <strong>Klant:</strong>&nbsp;{{ hoveringObj.customer ? hoveringObj.customer.firstname + ' ' +hoveringObj.customer.lastname : 'Geen klant' }}
                            <br><br>
                            <strong>{{ hoveringObj.status == 'taken+reserved' ? 'Ingang nieuw contract' : 'Beschikbaar vanaf' }}:</strong>&nbsp;{{ hoveringObj.status == 'free' ? 'Direct' : hoveringObj.available_at ? moment(hoveringObj.available_at).format('DD-MM-Y') : 'N.v.t.' }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Example floorplan JSON
// {"0":{"name":"Begane grond","image":"/uploads/organisations/2/floorplans/miniopslag-bg.jpg"},"1":{"name":"Eersteverdieping","image":"/uploads/organisations/2/floorplans/miniopslag-verdieping1.jpg"}}

// {
//   "0": {
//     "name": "Begane grond",
//     "image": "/uploads/organisations/2/floorplans/miniopslag-bg.jpg",
//   },
//   "1": {
//     "name": "Eersteverdieping",
//     "image": "/uploads/organisations/2/floorplans/miniopslag-verdieping1.jpg",
//   }
// }

///////////////////////////////////////////////////////////
// Het maken van de map en het maken van de box SVG path's
///////////////////////////////////////////////////////////
// Je moet de SVG openen in illustrator, bestand even groot maken als de afbeelding.
// Illustrator heeft er een handje van om afbeeldingen kleiner te maken dan ze eigenlijk zijn.
// .. Daarna de tekening maken, anders kloppen de verhoudingen dus niet.
// Belangrijk is dat de gemaakte objecten (boxen) een "Compound Pad" is, of in het NL "Samengesteld pad". (CTRL+8 of Object > Samengesteld pad)
// Selecteer alle objecten + achtergrond(BELANGRIJK VOOR X-Y COORDINATIE!!). Plak in texteditor.
// Nu zie je dus de data. (TIP: Als je alles netjes in lagen zet dan kan je ze makkelijker terugvinden.)
// Seed met commando uit /database/seeds/BoxSeederFloorplan.php >   php artisan db:seed --class=BoxSeederFloorplan

import Raphael from '@/js/raphael.min.js'
import PinchZoom from 'vue-pinch-zoom'
import BoxesOverviewStatus from './BoxesOverviewStatus.vue'
import escalationMixin from '@/mixins/escalationMixin.js'
import statusFiltersMixin from '@/mixins/statusFiltersMixin.js'

export default {
    components: {
        PinchZoom,
        BoxesOverviewStatus
    },

    mixins: [escalationMixin, statusFiltersMixin],

    data () {
        return {
            updateKey: 0,
            floorPlan: false,
            loading: false,
            showInfo: false,
            hoveringObj: null,
            leftSided: false,

            activeFloor: this.$store.state.user?.settings?.open_preference == 4
                ? _.has(this.$store.state.user?.settings, 'last_opened_floorplan')
                    ? this.$store.state.user.settings.last_opened_floorplan
                    : 0
                : 0,
            firstBoot: true,
            boxes: [],

            // Only show this box.
            showOnlyBox: null,
            boxesFound: [],
            selectedBox: null,
            isFetching: false
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        dataBelongsTo() {
            return this.$store.state.dataBelongsTo
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },

        organisations() {
            return this.$store.state.organisations
        }

        // selectedFilters: {
        //     get() {
        //         return this.$store.state.selectedFilters || this.possibleFilters.map(f => f.name)
        //     },
        //     set(value) {
        //         this.$store.dispatch('setSelectedFilters', value)
        //     }
        // }
    },

    created() {
        // this.startUpFloorPlan()
    },

    methods: {
        startUpFloorPlan(){
            this.showInfo = false // reset info box if it was open.

            this.getFloorplanSize().then((image) => {
                this.loading = true

                // Clear
                document.querySelectorAll('#floorplan')[0].innerHTML = ""

                // Initialize Raphael
                let floorPlan = Raphael("floorplan", image.width, image.height)

                // Set background (floorplan)
                document.querySelectorAll('#floorplan svg')[0].style.backgroundImage = 'url('+image.src+')'
                document.querySelectorAll('#floorplan svg')[0].style.backgroundSize = 'contain'
                document.querySelectorAll('#floorplan svg')[0].style.backgroundRepeat = 'no-repeat'

                // Set view box
                floorPlan.setViewBox(0, 0, image.width, image.height, true)
                floorPlan.setSize('100%', '100%') // responsive scaling

                // Set up boxes belonging to
                this.fetchBoxes().then(() => {
                    this.setUpBoxes(floorPlan).then(() => {
                        setTimeout(() => {
                            this.loading = false
                            this.openPreferencedFloorplan()
                        }, 150)
                    })
                })
            })
        },

        getFloorplanSize(){
            return new Promise((resolve, reject) => {
                if(this.user.role === 'pit'){
                    if(this.dataBelongsTo != 'all'){
                        const organisation = this.organisations[this.dataBelongsTo]
                        let floorPlan = organisation.floorplan

                        if(floorPlan){
                            try {
                                this.$set(this, 'floorPlan', JSON.parse(floorPlan))
                            } catch(e) {
                                console.log('Floorplan cannot be parsed to JSON!', e)
                            }
                        } else {
                            this.floorPlan = null
                        }
                    } else {
                        // Nothing to load. Select first.
                        this.floorPlan = false
                    }
                } else {
                    this.floorPlan = !_.isNull(this.user.floorplan) ? JSON.parse(this.user.floorplan) : null
                }

                if(!this.floorPlan) return false;

                const img = new Image()
                img.onload = function() {
                    resolve(this)
                }

                if (this.floorPlan && Object.keys(this.floorPlan).length <= this.activeFloor) {
                    this.activeFloor = 0
                    this.startUpFloorPlan()
                    return
                }

                const image = this.floorPlan[this.activeFloor]?.image

                if(!image) {
                    console.error('[❌] No image found for floorplan!')
                    reject()
                } else {
                    img.src = image
                }
            })
        },

        fetchBoxes(){
            return new Promise((resolve, reject) => {
                let params = [
                    `floor=${this.activeFloor}`,
                    'paginate=1000'
                ]

                if(this.user?.role === 'pit'){
                    params.push(`organisation=${this.dataBelongsTo}`)
                }

                // Add status filter if selected not 'all'
                if (this.selectedFilters.length > 0 && this.selectedFilters.length !== this.possibleFilters.length) {
                    params.push(`status=${this.selectedFilters.join(',')}`)
                }

                params = params.join('&')

                // axios get boxes where floor = this.activeFloor.
                axios.get(`/api/boxes?${params}`, {
                    headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
                }).then((response) => {
                    this.boxes = response.data.data
                    resolve()
                }).catch((error) => {
                    console.error('[❌] Error while fetching the boxes:', error)
                    reject()
                }).then(() => {
                    this.searchParams = null
                })
            })
        },

        setUpBoxes(floorPlan){


            _.forEach(this.boxes, (box) => {
                // if box.status is not in selectedFilters, skip this box.
                if(!this.selectedFilters.includes(box.status)) return

                // Handle showOnlyBox as array
                if(this.showOnlyBox && this.showOnlyBox.length) {
                    const boxIds = this.showOnlyBox.map(b => b.id)
                    if(!boxIds.includes(box.id)) return
                } else if(this.showOnlyBox && this.showOnlyBox.id && this.showOnlyBox.id != box.id) {
                    return
                }

                const path = floorPlan.path(box.path).attr({
                    // fill: box.status == 'free' ? 'green' : box.status == 'taken' ? 'red' : '#ededed',
                    stroke: '#666',
                    'stroke-width': 1,
                    'stroke-linejoin': 'round',
                    class: 'box '+box.status.replace('+', ''),
                }).click(() => {
                    this.boxClick(box)
                }).mousemove((obj) => {
                    let widthOfBox = this.$refs.boxinfo.offsetWidth
                    this.showInfo = true

                    if(obj.view.innerWidth < 1800){
                        // Left sided infobox
                        if((obj.clientX + widthOfBox) >= obj.view.innerWidth){
                            this.hoveringObj = box
                            this.leftSided = true
                            this.$refs.boxinfo.style.top = (obj.clientY + 10) + 'px';
                            this.$refs.boxinfo.style.left = (obj.clientX - widthOfBox) + 'px';
                        } else {
                            this.hoveringObj = box
                            this.leftSided = false
                            this.$refs.boxinfo.style.top = (obj.clientY + 10) + 'px';
                            this.$refs.boxinfo.style.left = (obj.clientX + 10) + 'px';
                        }
                    } else {
                        this.hoveringObj = box
                        this.leftSided = false
                        this.$refs.boxinfo.style.top = (obj.clientY + 10) + 'px';
                        this.$refs.boxinfo.style.left = (obj.clientX + 10) + 'px';
                    }
                })

                path.mouseout(() => {
                    this.showInfo = false
                    this.hoveringObj = null
                })

                // Add text (box number) to box
                this.addTextToPath(path, box)
            })

            return new Promise((resolve) => {
                resolve()
            })
        },

        addTextToPath(path, box){
            let textattr = { 'font-size': 8, stroke: 'none', 'font-family': 'Arial,Helvetica,sans-serif', 'font-weight': 400 }
            let bbox = path.getBBox()
            let textObj = path.paper.text(bbox.x + bbox.width / 2, bbox.y + bbox.height / 2, box.number).attr( textattr );

            // Initialize click action
            textObj.click(() => {
                this.boxClick(box)
            })

            return textObj
        },

        boxClick(box){
            if(_.has(this.user, 'settings.clickbox') && this.user.settings.clickbox == 2){
                console.log('[🚀] Redirecting you to the contract to create for box: '+box.id+'!')

                if(box.customer_id){
                    this.$router.push({name: 'ContractsRecord', params: {id: 'nieuw'}, params: {id: 'nieuw'}, query: {'box': box.id, 'customer': box.customer_id}})
                } else {
                    this.$router.push({name: 'ContractsRecord', params: {id: 'nieuw'}, query: {'box': box.id}})
                }
            } else {
                console.log('[🚀] Redirecting you to the box record page with id: '+box.id+'!')
                this.$router.push('/panel/artikelen/boxen/'+box.id)
            }

        },

        updateBoxesWithFilters: _.debounce(function(){
            this.updateKey = this.updateKey + 1
            this.startUpFloorPlan()
        }, 250),

        // Show box by searching it (BoxOverview > Floorplan)
        selectBox(boxes){
            if (_.isNull(boxes)) {
                this.showOnlyBox = null
                this.startUpFloorPlan()
                return
            }

            // If we received a single box, convert it to an array
            if (!Array.isArray(boxes)) {
                boxes = [boxes]
            }

            // Count boxes per floor
            const floorCounts = {}
            boxes.forEach(box => {
                floorCounts[box.floor] = (floorCounts[box.floor] || 0) + 1
            })

            // Find the floor with the most boxes
            const floorEntries = Object.entries(floorCounts)
                .sort((a, b) => b[1] - a[1])

            // If we have multiple floors with the same count, prefer the current floor
            let mostCommonFloor = floorEntries[0][0]
            const maxCount = floorEntries[0][1]

            // Check if there are other floors with the same count
            const floorsWithMaxCount = floorEntries
                .filter(([_, count]) => count === maxCount)
                .map(([floor]) => parseInt(floor))

            // If current floor is one of the floors with max count, use it
            if (floorsWithMaxCount.includes(this.activeFloor)) {
                mostCommonFloor = this.activeFloor
            } else {
                mostCommonFloor = parseInt(mostCommonFloor)
            }

            // If we need to change floors, do that first
            if (this.activeFloor != mostCommonFloor) {
                this.activeFloor = mostCommonFloor
                // Wait for the floor to change before showing boxes
                this.$nextTick(() => {
                    this.showOnlyBox = boxes
                    this.startUpFloorPlan()
                })
            } else {
                this.showOnlyBox = boxes
                this.startUpFloorPlan()
            }
        },

        openPreferencedFloorplan() {
            if(_.has(this.user, 'settings.open_preference') && this.user.settings.open_preference == 3 && this.floorPlan){
                if (this.firstBoot) {
                    this.activeFloor = 0
                    this.firstBoot = false
                }
            } else if(_.has(this.user, 'settings.open_preference') && this.user.settings.open_preference == 4 && this.floorPlan){
                if (this.$store.state.user.settings.last_opened_floorplan !== undefined && this.firstBoot) {
                    this.activeFloor = this.$store.state.user.settings.last_opened_floorplan
                    this.firstBoot = false
                }
            }
        },

        findBox: _.debounce(function (name) {
            if (!name.length) {
                this.boxesFound = []
                return
            }
            this.isFetching = true

            let searchParm = `search=${name}`
            if (this.user?.role === 'pit') {
                searchParm += `&organisation=${this.dataBelongsTo}`
            }

            // Add status filter if selected not 'all'
            if (this.selectedFilters.length > 0 && this.selectedFilters.length !== this.possibleFilters.length) {
                searchParm += `&status=${this.selectedFilters.join(',')}`
            }

            axios.get(`/api/boxes/find?${searchParm}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.boxesFound = response.data.data

                if (response.data.data.length > 0) {
                    // Show all matching boxes on the map
                    this.selectBox(response.data.data)
                }
            }).catch((error) => {
                console.error('[❌] Error while searching box:', error)
            }).then(() => {
                this.isFetching = false
            })
        }, 250),
    },

    watch: {
        user(newVal, oldVal){
            if(Object.keys(newVal).length > 0 && Object.keys(oldVal).length === 0){
                this.startUpFloorPlan()
            }
        },

        dataBelongsTo(newVal, oldVal){
            if(newVal !== oldVal){
                this.startUpFloorPlan()
            }
        },

        activeFloor(newVal, oldVal){
            if(newVal !== oldVal){
                this.startUpFloorPlan()
                this.$store.dispatch('setLastOpenedFloorplan', newVal)
            }
        },

        selectedFilters: {
            handler() {
                this.loading = true
                this.showOnlyBox = null
                this.updateBoxesWithFilters()
            },
            immediate: true
        }
    }
}
</script>